import axios from 'axios';
import CryptoJS from 'crypto-js';


class API {
  constructor(domain, myaccountDomain) {
    this.domain = domain || 'http://localhost:19550'; // API server domain
    this.authCall = this.authCall.bind(this);
    this.appId = process.env.REACT_APP_APPID;
    this.apiKey = process.env.REACT_APP_APIKEY;
    this.myAccount = {
      url: myaccountDomain || 'http://localhost:51456',
      appId: process.env.REACT_APP_MYACCOUNT_APPID,
      apiKey: process.env.REACT_APP_MYACCOUNT_APIKEY 
    };
    this.eAPI = {
      mainDomain: process.env.REACT_APP_SITE,
      url: domain || 'http://localhost:19550',
      appId:  process.env.REACT_APP_APPID,
      apiKey: process.env.REACT_APP_APIKEY,
      mainSite: process.env.REACT_APP_SITE
    };
  }

  authCall = (domain, url, methodType, data) => {
    let fullpath = domain.url + url;
    let domainpath = this.eAPI.mainDomain + url;
    return axios({ 
      url: domainpath,
      method: methodType,
      headers: { 
        'Authorization': this.generateAMXHeader(fullpath, methodType, data, domain.appId, domain.apiKey),
        'Accept' : 'application/json',
        'Content-Type': 'application/json',
      },
      data: data,
    })
    .then(response => {
      if (response.data.Errors !== null && response.data.Errors !== undefined) {
        return Promise.reject(response.data.Errors);
      } else {
        return Promise.resolve(response.data.Result);
      }
    })
    .catch(error => {
      return Promise.reject(error);
    });
  }


  stringToBytes = ( str ) => {
    let ch, st, re = [];
    for (let i = 0; i < str.length; i++ ) {
      ch = str.charCodeAt(i);  // get char 
      st = [];                 // set up "stack"
      do {
        st.push( 0, ch & 0xFF );  // push byte to stack
        ch = ch >> 8;          // shift value down by 1 byte
      }  
      while ( ch );
      // add stack contents to result
      // done because chars have "wrong" endianness
      re = re.concat( st.reverse() );
    }
    // return an array of bytes
    return re;
  }

  byteArrayToWordArray = (ba) => {
    let wa = [],
    i;
    for (i = 0; i < ba.length; i++) {
      wa[(i / 4) | 0] |= ba[i] << (24 - 8 * i);
    }
    return CryptoJS.lib.WordArray.create(wa, ba.length);
  }

  generateNonce = (length) => {
    let nonce = '';
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
      nonce += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return nonce;
  }

  generateAMXHeader = (uri, methodType, bodyData, appId, apiKey) => {
    let encodedUri = encodeURIComponent(uri).toLowerCase();
    let unixTimestamp = Math.round((new Date()).getTime() / 1000);
    let nonce = this.generateNonce(20);
    let bodyContent = '';
    if (bodyData !== null && bodyData !== undefined) {
      let data = JSON.stringify(bodyData);
      let bodyBytes = this.stringToBytes(data);
      let bodyHash = CryptoJS.SHA512(this.byteArrayToWordArray(bodyBytes));
      bodyContent = CryptoJS.enc.Base64.stringify(bodyHash);
    }
    
    let rawSignatureData = `${appId}${methodType}${encodedUri}${unixTimestamp}${nonce}${bodyContent}`;
    let hash = CryptoJS.HmacSHA256(rawSignatureData, apiKey, { asBytes: true });
    let signature = CryptoJS.enc.Base64.stringify(hash);
    let amx = `amx ${appId}:${signature}:${nonce}:${unixTimestamp}`
    return amx;
  }

  

  getCheckCardDetails = (cardNumber, nameOnCard, email, cardTypeId, myAccountUser) => {
    let url = `/api/carddetails?cardNumber=${encodeURIComponent(cardNumber)}&nameOnCard=${encodeURIComponent(nameOnCard)}&email=${encodeURIComponent(email)}&cardTypeId=${encodeURIComponent(cardTypeId)}&myAccountUser=${encodeURIComponent(myAccountUser)}`
    return this.authCall(this.eAPI,url, 'GET')
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  getExtranetSiteRulesWithId = (id, culture) => {
    let url = `/api/extranetsiterules/id/${encodeURIComponent(id)}/${encodeURIComponent(culture)}`;
    return this.authCall(this.eAPI,url, 'GET')
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  getExtranetSiteRulesWithCode = (code, culture) => {
    let url = `/api/extranetsiterules/code/${encodeURIComponent(code)}/${encodeURIComponent(culture)}`;
    return this.authCall(this.eAPI ,url, 'GET')
    .then(response => {
      // const UIDefault = JSON.parse(response.Settings[0].Value);
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  getTermsAndConditions = () => {
    let url = `/api/extranetsiterules/code/info/en-gb`;
    return this.authCall(this.eAPI ,url, 'GET')
        .then(response => {
         // console.log(response);
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        })
  }

  postSessionData = (sessionData) => {
    let url = `/api/sessiondata`;
    return this.authCall(this.eAPI ,url, 'POST', sessionData)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  getSessionData = (sessionId) => {
    let url = `/api/sessiondata?sessionId=${encodeURIComponent(sessionId)}`;
    return this.authCall(this.eAPI ,url, 'GET')
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  getEComponentURL = (EComponentUrlRequest) => {
    let url = `/api/ecomponent/url`;
    return this.authCall(this.eAPI ,url, 'POST', EComponentUrlRequest)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  postCardActivationConfirmationEmail = (cardActivationConfirmationEmail) => {
    let url = `/api/cardactivation/email/confirmation`;
    return this.authCall(this.eAPI ,url, 'POST', cardActivationConfirmationEmail)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  postReCaptcha = (recaptcha) => {
    let url = `/api/security/recaptcha`;
    return this.authCall(this.eAPI ,url, 'POST', recaptcha)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    })
  }

  setAccountActive = (verification_code, password, username) => {
    let url = `/api/user/${username}/verify-email`;
    return this.authCall(this.eAPI ,url, 'POST',{verification_code, password})
        .then(response => {
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        })

  }

  resetNewPassword = (validation_code, password, username) => {
    let url = `/api/user/${username}/reset-password`;
    return this.authCall(this.eAPI ,url, 'POST',{validation_code, password})
        .then(response => {
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        })
  }

  requestNewPassword = (username) => {
    let url = `/api/user/${username}/request-password-reset`;
    return this.authCall(this.eAPI ,url, 'POST')
        .then(response => {
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        })
  }

  veryfyEmailChange = (username, token) => {
    let url = `/api/user/${username}/verify-email-change`;
    return this.authCall(this.eAPI ,url, 'POST', {token})
        .then(response => {
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        })
  }


}

export default API;


// WEBPACK FOOTER //
// ./src/api/api.js